$shm_period $mol_view
	sub /
		<= Date_from $shm_date_view
			value? <=> date_from? \
		\–
		<= Date_to $shm_date_view
			value? <=> date_to? \
	period_str? \
	period? *
		from \
		to \
	clear null
